import React, { useState, useEffect } from 'react'
import { useTranslate, useNotify, useRefresh, useRecordContext } from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import EventIcon from '@mui/icons-material/Event'
import PhoneIcon from '@mui/icons-material/Phone'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import MedicalServicesIcon from '@mui/icons-material/MedicalServices'
import { afterSalesItemReservation } from 'src/components/pages/sales/reservation/helper/afterSalesItemReservation'
import LinkIcon from '@mui/icons-material/Link'
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TableContainer,
  Table,
  TableBody,
  Typography,
  TextField,
  Button,
  IconButton,
  Backdrop,
  CircularProgress,
  Tooltip,
  Checkbox,
} from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import {
  ShowCard,
  RigthSideCard,
  LeftSideCard,
  CompleteSideCard,
} from 'src/components/uiElements/cards/ShowCard'
import { cancelItemReservation } from 'src/components/pages/sales/reservation/helper/cancelItemReservation'
import { Passenger } from 'src/components/pages/sales/reservation/logic/common/Passenger'
import { DateProduct } from 'src/components/pages/sales/reservation/logic/common/DateProduct'
import { turquoise } from 'src/assets/colors'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { blue } from 'src/assets/colors'
import { TabProduct } from 'src/components/pages/sales/reservation/logic/common/TabProduct'
import { ToolbarReservation } from 'src/components/pages/sales/reservation/logic/common/ToolbarReservation'
import { ContactModal } from 'src/components/pages/sales/reservation/logic/modals/ContactModal'
import { handleUpdateContact } from 'src/components/pages/sales/reservation/helper/handleUpdateContact'
import { handleUpdatePricing } from 'src/components/pages/sales/reservation/helper/handleUpdatePricing'
import { PricingModal } from 'src/components/pages/sales/reservation/logic/modals/PricingModal'
import { LiquidationPricing } from 'src/components/pages/sales/reservation/logic/common/LiquidationPricing'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { WrapperCardId } from 'src/components/pages/sales/reservation/logic/common/WrapperCardId'
import { deleteItemReservation } from 'src/components/pages/sales/reservation/helper/deleteItemReservation'
import { AssistanceForm } from 'src/components/pages/sales/reservation/logic/assistance/AssistanceForm'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { guaranteeItemReservation } from 'src/components/pages/sales/reservation/helper/guaranteeItemReservation'
import { cloneItemReservation } from 'src/components/pages/sales/reservation/helper/cloneItemReservation'
import { Comment } from '@mui/icons-material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { emitItemReservation } from 'src/components/pages/sales/reservation/helper/emitItemReservation'
import { INVOICED } from 'src/components/pages/sales/reservation/logic/common/state'
import { BillingStatusField } from 'src/components/pages/sales/reservation/logic/common/BillingStatusField'
import {
  PERMISSION_IS_BILLABLE,
  PERMISSION_SHOW,
  VIEW_LIQUIDATION_RETAIL,
  VIEW_LIQUIDATION_SUPPLIER,
  VIEW_LIQUIDATION_WHOLESALER,
} from 'src/helper/Permission'
import { NotificationEmails } from 'src/components/pages/sales/reservation/logic/common/NotificationEmails'
import { FilesCard as FilesCardComponent } from '../common/FilesCard'
import { BillingAutomaticField } from '../common/BillingAutomaticField'
import { hasLiquidation, hasNotErrorInliquidation } from 'src/components/pages/sales/reservation/logic/common/hasLiquidation'

import { DueDateOfProduct } from '../common/DueDateOfProduct'
import { useReservationInfo } from '../../context/ReservationContext'
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { ExchangeType } from '../common/ExchangeType'
import {CommentsCardComponent} from '../common/CommentsCardComponent'
import { EditOriginValues } from '../common/EditOriginValues'
import { PostVentaStatus } from '../common/postventaStatus'
import { registerReturn } from '../../helper/registerReturn'
import { HistoryCostsDialog } from '../common/HistoryCostsDialog'
import CloseIcon from '@mui/icons-material/Close';
import { ChangeStatusDialog } from '../common/ChangeStatusDialog'
import { AssistanceCancellation } from './AssistanceCancellation'
import { pricingServices } from 'src/services/reservation/pricing/pricing.service'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'

const VoucherAssistance = () => {
  const assistance = useRecordContext()
  const translate = useTranslate()

  const redirect = () => {
    window.open('https://www.google.com', '_blank')
  }

  return assistance?.url_voucher ? (
    <ShowElement
      styleValue={{ fontWeight: 600, color: turquoise }}
      label={translate('ra.field.donwload_voucher')}
      icon={
        <IconButton aria-label='fingerprint' color='success' onClick={redirect}>
          <LinkIcon />
        </IconButton>
      }
    />
  ) : null
}

const PassengerAssistance = ({ reservation }) => {
  const assistance = useRecordContext()
  const translate = useTranslate()

  const getTitularPassenger = () => {
    if (reservation?.passenger) {
      return reservation?.passenger
    } else {
      const passenger = assistance?.pax_relation?.find((elem) => elem.is_titular)
      return passenger ? `${passenger.name} ${passenger.surname}` : ''
    }
  }

  return <ShowElement data={getTitularPassenger()} label={translate('ra.field.passenger')} />
}

const ContextAssistance = ({ reservation }) => {
  const assistance = useRecordContext()
  if (assistance) {
    return (
      <>
        <HasPermission permission={PERMISSION_SHOW} resource={DUE_DATE_RANGE_PERMISSION_ENTITY}>
          <DueDateOfProduct />
        </HasPermission>
        <DateProduct date_in={assistance?.date_in} date_out={assistance?.date_out} />
        <AssistanceCancellation autoCancelDate={assistance?.autocancel_date} cancellations={assistance?.cancel_info_relation} />
        <Passenger
          itemId={assistance.item_id}
          passengers={assistance?.pax_relation}
          idResource={reservation?.id}
        />
      </>
    )
  }
}

const ContextAssistanceForm = ({ reservation, openProductModal, onSubmitProduct, setOpenProductModal }) => {
  const assistance = useRecordContext()
  if (assistance && openProductModal) {
    return (
      <AssistanceForm
        openModal={openProductModal}
        reservation={reservation}
        passengers={reservation?.passengers}
        workUnit={reservation.work_unit_relation}
        product={assistance}
        handleClose={() => setOpenProductModal(false)}
        onSubmit={(data, cardId) => onSubmitProduct(data, cardId)}
        recordProduct={assistance}
      />
    )
  }
}

const ObservationsCard = () => {
  const translate = useTranslate()
  const item = useRecordContext()
  if (item && item.observations) {
    return (
      <ShowCard iconHeader={<Comment />} title={translate('ra.title.observations')} variant='text'>
        <CompleteSideCard>
          <ShowElement source='observations' onlyValue />
        </CompleteSideCard>
      </ShowCard>
    )
  }
}

const LiquidationCards = ({ work_unit_relation,enableReliquidation }) => {
  const translate = useTranslate()
  const item = useRecordContext()
  const notify = useNotify()
  const refresh = useRefresh()
  const [refreshLiquidation, setRefreshLiquidation] = useState(0)
  const [openReliquidateModal, setOpenReliquidateModal] = useState(false)
  const [confirmReliquidate, setConfirmReliquidate] = useState(false)
  const [reliquidateType, setReliquidateType] = useState(0)
  const [reliquidateLoading, setReliquidateLoading] = useState(false)
  
  const onReliquidate = async () =>{
    setReliquidateLoading(true)
    if(reliquidateType === 0){
      await pricingServices.reliquidate_wholesaler([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 1){
      await pricingServices.reliquidate_retail([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    else if(reliquidateType === 2){
      await pricingServices.reliquidate_supplier([item.hash_]).then(()=>{
        setOpenReliquidateModal(false)
        setConfirmReliquidate(false)
        refresh()
        setTimeout(() => {
          setRefreshLiquidation(refreshLiquidation+1)
        }, 2000);
      }).catch(()=>{
        notify('ra.message.reliquidation_error', {type:'error'})
      }).finally(()=>{
        setReliquidateLoading(false)
      })
    }
    
  }

  useEffect(()=>{
    if(confirmReliquidate){
      onReliquidate()
    }
  },[confirmReliquidate])

  const decideLiquidation = () =>{
    if(reliquidateType === 0){
      return translate('ra.title.liquidation_wholesaler')
    }
    if(reliquidateType === 1){
      return translate('ra.title.liquidation_retail')
    }
    if(reliquidateType === 2){
      return translate('ra.title.liquidation_supplier')
    }
  }

  return (
    <>
      <ExchangeType />
      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_wholesaler) && (
        <HasPermission permission={VIEW_LIQUIDATION_WHOLESALER} resource={'pricing'}>
          <ShowCard
            iconHeader={
              <Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_wholesaler')&& enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(0)
                    }
                  }}
                />
              </Tooltip>
            }
            title={translate('ra.title.liquidation_wholesaler')}
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`wholesaler${refreshLiquidation}`}>
                  <LiquidationPricing
                    node_liquidation='liquidation_wholesaler'
                    work_unit_relation={work_unit_relation}
                  />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_retail) &&
        hasNotErrorInliquidation(item?.pricing_relation?.[0]?.liquidation_retail) && (
          <HasPermission permission={VIEW_LIQUIDATION_RETAIL} resource={'pricing'}>
            <ShowCard
              iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler') && enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_retail') && enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(1)
                    }
                  }}
                />
              </Tooltip>}
              title={translate('ra.title.liquidation_retail')}
              variant='text'
              optionHeigth={'liquidation'}
            >
              <TableContainer>
                <Table>
                  <TableBody key={`retail${refreshLiquidation}`}>
                    <LiquidationPricing
                      node_liquidation='liquidation_retail'
                      work_unit_relation={work_unit_relation}
                    />
                  </TableBody>
                </Table>
              </TableContainer>
            </ShowCard>
          </HasPermission>
        )}

      {hasLiquidation(item?.pricing_relation?.[0]?.liquidation_supplier) && (
        <HasPermission permission={VIEW_LIQUIDATION_SUPPLIER} resource={'pricing'}>
          <ShowCard
            iconHeader={<Tooltip title={hasPermissionFunction('pricing', 'edit_liquidation_supplier')&& enableReliquidation && translate('ra.action.reliquidate')}>
                <AttachMoneyIcon 
                  color={hasPermissionFunction('pricing', 'edit_liquidation_wholesaler')&& enableReliquidation ? 'primary' : 'inherit'}
                  style={{cursor:hasPermissionFunction('pricing', 'edit_liquidation_supplier')&& enableReliquidation ? 'pointer' : 'default'}}
                  onClick={async ()=>{
                    if(hasPermissionFunction('pricing', 'edit_liquidation_supplier')&& enableReliquidation){
                      setOpenReliquidateModal(true)
                      setReliquidateType(2)
                    }
                  }}
                />
              </Tooltip>}
            title={translate('ra.title.liquidation_supplier')}
            variant='text'
            optionHeigth={'liquidation'}
          >
            <TableContainer>
              <Table>
                <TableBody key={`supplier${refreshLiquidation}`}>
                  <LiquidationPricing
                    node_liquidation='liquidation_supplier'
                    work_unit_relation={work_unit_relation}
                  />
                </TableBody>
              </Table>
            </TableContainer>
          </ShowCard>
        </HasPermission>
      )}
      <ConfirmationDialog
          title={decideLiquidation()}
          contentText={translate('ra.message.reliquidation_confirm', {liquidation:decideLiquidation()})}
          buttonConfirmText={translate('ra.message.yes')}
          buttonCancel={translate('ra.message.no')}
          setOpen={setOpenReliquidateModal}
          setConfirm={setConfirmReliquidate}
          open={openReliquidateModal}
          loadingModalButton={reliquidateLoading}
        />
    </>
  )
}

const FilesCard = () => {
  const translate = useTranslate()
  const assistance = useRecordContext()
  if (assistance) {
    return (
      <ShowCard title={translate('ra.title.files')}>
        <FilesCardComponent recordProduct={assistance} />
      </ShowCard>
    )
  }
}

export const AssistanceProduct = ({ reservation, assistance, editMode = false }) => {
  const translate = useTranslate()
  const refresh = useRefresh()
  const notify = useNotify()
  const [open, setOpen] = useState(false)
  const [nameReserve, setNameReserve] = useState('')
  const [hashItemReserve, setHashItemReserve] = useState('')
  const [confirm, setConfirm] = useState(false)
  // const [individualRecord, setIndividualRecord] = useState({})
  const [openPricingModal, setOpenPricingModal] = useState(false)
  const [loadingPricingModal, setLoadingPricingModal] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [loadingDeleteItem, setLoadingDeleteItem] = useState(false)
  const [openGuaranteeModal, setOpenGuaranteeModal] = useState(false)
  const [confirmGuarantee, setConfirmGuarantee] = useState(false)
  const [loadingGuaranteeItem, setLoadingGuaranteeItem] = useState(false)
  const [openMoveModal, setOpenMoveModal] = useState(false)
  const [loadingMoveItem, setLoadingMoveItem] = useState(false)
  const [reservationNumberMove, setReservationNumberMove] = useState('')
  // const [openLiqudiationPricingModal, setOpenLiqudiationPricingModal] = useState(false)
  // const [loadingLiqudiationPricingModal, setLoadingLiqudiationPricingModal] = useState(false)
  const [openContactModal, setOpenContactModal] = useState(false)
  const [loadingContactModal, setLoadingContactModal] = useState(false)

  const [openCloneModal, setOpenCloneModal] = useState(false)
  const [confirmClone, setConfirmClone] = useState(false)
  const [loadingCloneItem, setLoadingCloneItem] = useState(false)

  const [confirmEmit, setConfirmEmit] = useState(false)
  const [openEmitModal, setOpenEmitModal] = useState(false)
  const [loadingEmitItem, setLoadingEmitItem] = useState(false)
  const [wasEmitted, setWasEmitted] = useState({})

  const [openRegisterReturnModal, setOpenRegisterReturnModal] = useState(false)
  const [confirmRegisterReturn, setConfirmRegisterReturn] = useState(false)
  const [loadingRegisterReturnItem, setLoadingRegisterReturnItem] = useState(false)

  const [loadingCancelItem, setLoadingCancelItem] = useState(false)
  const { setOpenDueDateModal } = useReservationInfo()
  // const [exchangeMode, setExchangeMode] = useState(false)
  const [openProductModal, setOpenProductModal] = useState(false)
  const { setCardLoading } = useCardLoading()

  const [openAfterSalesModal, setOpenAfterSalesModal] = useState(false)
  const [confirmAfterSales, setConfirmAfterSales] = useState(false)
  const [loadingAfterSalesItem, setLoadingAfterSalesItem] = useState(false)

  const [changePostVentaStatus, setChangePostventaStatus] = useState(false)
  const [loadingPostventaStatus, setLoadingPostventaStatus] = useState(false)
  const [actualStatus, setActualStatus] = useState('')

  const [historyCostsDialog, setHistoryCostsDialog] = useState()

  const [changeStatusDialog, setChangeStatusDialog] = useState(false)

  const [isBillable, setIsBillable] = useState(assistance[0].is_billable)

  const [enableReliquidation, setEnableReliquidation] = useState(false)

  useEffect(()=>{
      const items = reservation.items
      const foundItem = items.find(item=>item.id === assistance[0].id)
      setIsBillable(foundItem.is_billable)
    },[reservation])

  useEffect(() => {
    if (confirmGuarantee) {
      guaranteeItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingGuaranteeItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmGuarantee,
        setOpenGuaranteeModal,
        onGuaranteeSuccess: () => {
          setOpenDueDateModal(true)
        },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmGuarantee])

  useEffect(() => {
    if (confirmClone) {
      cloneItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCloneItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmClone,
        setOpenCloneModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmClone])

  useEffect(() => {
      if (confirmRegisterReturn) {
        registerReturn({
          hashItemReserve,
          nameReserve,
          refresh,
          notify,
          setLoadingRegisterReturnItem,
          setNameReserve,
          setHashItemReserve,
          setConfirmRegisterReturn,
          setOpenRegisterReturnModal,
        })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [confirmRegisterReturn])

  useEffect(() => {
    if (confirmDelete) {
      deleteItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingDeleteItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmDelete,
        setOpenDeleteModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  useEffect(() => {
    if (confirm) {
      cancelItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingCancelItem,
        setNameReserve,
        setHashItemReserve,
        setConfirm,
        setOpen,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirm])

  useEffect(() => {
    if (confirmAfterSales) {
      afterSalesItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingAfterSalesItem,
        setNameReserve,
        setHashItemReserve,
        setConfirmAfterSales,
        setOpenAfterSalesModal,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmAfterSales])

  useEffect(() => {
    let wasEmittedKeys = Object.keys(wasEmitted)
    if (assistance && Array.isArray(assistance) && assistance.length > 0 && wasEmittedKeys.length > 0) {
      wasEmittedKeys.forEach((emit) => {
        const isEmmited = assistance.find((elem) => elem?.hash_ === emit && elem?.status === INVOICED)
        if (wasEmitted[emit] && isEmmited) {
          setWasEmitted((prev) => ({
            ...prev,
            [emit]: false,
          }))
          setLoadingEmitItem(false)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assistance, wasEmitted])

  useEffect(() => {
    if (confirmEmit) {
      emitItemReservation({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setHashItemReserve,
        setLoadingEmitItem,
        setNameReserve,
        setConfirmEmit,
        setOpenEmitModal,
        setWasEmitted,
        translate,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmEmit])

  useEffect(() => {
    if (changePostVentaStatus) {
      PostVentaStatus({
        hashItemReserve,
        nameReserve,
        refresh,
        notify,
        setLoadingPostventaStatus,
        setNameReserve,
        setHashItemReserve,
        setChangePostventaStatus,
        actualStatus
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changePostVentaStatus])

  const onSubmitProduct = (data, cardId) => {
    setCardLoading(cardId, true)
  }

  const handleMoveItem = async () => {
    if (reservationNumberMove) {
      setLoadingMoveItem(true)
      setOpenMoveModal(false)
      try {
        await itemServices.move_item(hashItemReserve, reservationNumberMove, reservation.number)
        notify('ra.notification.move_item_success', {
          type: 'success',
          messageArgs: { item: nameReserve },
        })
      } catch (error) {
        if(error.response.data?.detail){
          notify(error.response.data?.detail, {
            type: 'error',
          })
        } else {
          notify('ra.notification.move_item_error', {
            type: 'error',
            messageArgs: { item: nameReserve },
          })
        }
      } finally {
        customAwait([refresh])
        setNameReserve('')
        setHashItemReserve('')
        setReservationNumberMove('')
        setLoadingMoveItem(false)
      }
    }
  }

  const onChangeBillable = async () =>{
    const newValue = !isBillable
    setIsBillable(newValue)
    await reservationServices.updateIsBillableProduct(assistance[0].hash_, newValue).then(()=>{
      notify('ra.notification.updated_success_masculine', {
          type: 'success',
          messageArgs: { element: translate('ra.single_entity.product') },
        })
    }).catch(()=>{
      notify('ra.notification.updated_error_masculine', {
        type: 'error',
        messageArgs: { element: translate('ra.single_entity.product') },
      })
    })
  }

  if (assistance) {
    return (
      <>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loadingCancelItem || loadingDeleteItem}
        >
          <CircularProgress color='inherit' />
        </Backdrop>
        <TabProduct
          products={assistance}
          labelGetter={(product) =>
            product?.id_detail ? `${product.destination} / ${product.name}` : 'ERROR'
          }
          getStyle={(product) => (product?.id_detail ? null : { color: 'red' })}
        >
          {!editMode && (
            <ToolbarReservation
              resource='assistance-detail'
              loadingCancel={loadingCancelItem}
              onCancel={(assistance) => {
                setOpen(true)
                setHashItemReserve(assistance?.hash_)
                setNameReserve(`${assistance.destination} / ${assistance.name}`)
              }}
              reservation={reservation}
              onDeleted={(assistance) => {
                setOpenDeleteModal(true)
                setHashItemReserve(assistance?.hash_)
                setNameReserve(`${assistance.destination} / ${assistance.name}`)
              }}
              loadingDeleteItem={loadingDeleteItem}
              onGuaranteed={(assistance) => {
                setOpenGuaranteeModal(true)
                setHashItemReserve(assistance?.hash_)
                setNameReserve(`${assistance.destination} / ${assistance.name}`)
              }}
              loadingGuaranteeItem={loadingGuaranteeItem}
              onClone={(assistance) => {
                setOpenCloneModal(true)
                setHashItemReserve(assistance?.hash_)
                setNameReserve(`${assistance.destination} / ${assistance.name}`)
              }}
              loadingCloneItem={loadingCloneItem}
              onMove={(assistance) => {
                setOpenMoveModal(true)
                setHashItemReserve(assistance?.hash_)
                setNameReserve(`${assistance.destination} / ${assistance.name}`)
              }}
              loadingMoveItem={loadingMoveItem}
              onEmit={(assistance) => {
                setOpenEmitModal(true)
                setHashItemReserve(assistance?.hash_)
                setNameReserve(assistance?.provider)
              }}
              loadingEmitItem={loadingEmitItem}
              setOpenProductModal={setOpenProductModal}
              onAfterSales={(assistance)=>{
                setOpenAfterSalesModal(true)
                setHashItemReserve(assistance?.hash_)
                setNameReserve(assistance?.provider)}
              }
              setLoadingMoveItem={setLoadingMoveItem}
              loadingAfterSales={loadingAfterSalesItem}
              setLoadingAfterSalesItem={setLoadingAfterSalesItem}
              onRegisterReturn={
                (assistance)=>{
                  setOpenRegisterReturnModal(true)
                  setHashItemReserve(assistance?.hash_)
                  setNameReserve(assistance?.provider)}
              }
              loadingRegisterReturn = {loadingRegisterReturnItem}
              setLoadingRegisterReturn = {setLoadingRegisterReturnItem}
              postventaStatusButton={(assistance)=>{
                setChangePostventaStatus(true)
                setHashItemReserve(assistance?.hash_)
                setActualStatus(assistance.status)
              }}
              loadingPostventaStatus={loadingPostventaStatus}
            />
          )}

          <Box display={'flex'}>
            <div className='responsive-products-info'>
              <WrapperCardId>
                <ContextAssistanceForm
                  reservation={reservation}
                  openProductModal={openProductModal}
                  onSubmitProduct={(data, cardId) => onSubmitProduct(data, cardId)}
                  setOpenProductModal={setOpenProductModal}
                />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} lg={12} xl={8}>
                    <ShowCard iconHeader={<EventIcon />} title={translate('ra.title.reserve_information')}>
                      <CompleteSideCard>
                        <Box display={'flex'}>
                          <LeftSideCard>
                            <div style={{display:'flex', flexDirection:'row', alignItems:'center', whiteSpace:'nowrap'}}>
                              <ShowElement source='status' label={translate('ra.field.status')} />
                              <HasPermission resource={'item'} permission='edit_status'>
                                <EditIcon onClick={()=>setChangeStatusDialog(true)} style={{cursor:'pointer', fontSize:'18px', color:'#6f7ce0', marginLeft:'15px'}}/>
                              </HasPermission>
                            </div>
                            <ShowElement
                              source='created_at'
                              label={translate('ra.field.created_at')}
                              dateTime
                            />
                            <ShowElement
                              source='source_relation.short_name'
                              label={translate('ra.field.source')}
                            />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement
                              source={'payment_status'}
                              label={translate('ra.field.payment_status')}
                              status
                            />
                            <PassengerAssistance reservation={reservation} />
                            <BillingStatusField />
                            {hasPermissionFunction('item', PERMISSION_IS_BILLABLE) && (
                              <Box /* style={{padding: '5px 0px 5px 0px'}} */>
                                <Typography
                                    variant='h7'
                                    component='span'
                                    style={{
                                      padding: '0px 5px 0px 5px',
                                      fontWeight: 600,
                                      flex: 1,
                                      maxWidth: 'fit-content'
                                    }}
                                  >
                                  {translate('ra.field.is_billable')}
                                  <Checkbox checked={isBillable} onChange={onChangeBillable}/>
                                </Typography>
                              </Box>
                            )}
                            <BillingAutomaticField />
                          </RigthSideCard>
                        </Box>
                        <Typography variant='h6' component='div' color={blue} margin={'25px 5px 10px 5px'}>
                          {translate('ra.title.provider_info')}
                        </Typography>
                        <Box display={'flex'}>
                          <LeftSideCard>
                            <ShowElement
                              source='supplier_relation.name'
                              label={translate('ra.field.provider')}
                            />
                            <ShowElement
                              source={'pricing_relation.[0].currency_origin'}
                              label={translate('ra.field.currency')}
                            />
                          </LeftSideCard>
                          <RigthSideCard>
                            <ShowElement source={'code'} label={translate('ra.field.provider_code')} />
                          </RigthSideCard>
                        </Box>
                      </CompleteSideCard>
                    </ShowCard>
                    <ConfirmationDialog
                      title={translate('ra.message.cancel_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpen}
                      setConfirm={setConfirm}
                      open={open}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.delete_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenDeleteModal}
                      setConfirm={setConfirmDelete}
                      open={openDeleteModal}
                      loadingModalButton={loadingDeleteItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.guarantee_item_reserva', { item: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenGuaranteeModal}
                      setConfirm={setConfirmGuarantee}
                      open={openGuaranteeModal}
                      loadingModalButton={loadingGuaranteeItem}
                    />
                    <Dialog fullWidth maxWidth={'lg'} open={historyCostsDialog} onClose={() => setHistoryCostsDialog(false)}>
                      <DialogTitle style={{display:'flex', flexDirection:'row', width:'100%', justifyContent:'space-between'}}>{translate('ra.title.price_history')}
                        <CloseIcon style={{cursor:'pointer'}} onClick={()=>{setHistoryCostsDialog(false)}}/>
                      </DialogTitle>
                      <DialogContent>
                          <HistoryCostsDialog/>
                      </DialogContent>
                    </Dialog>
                    <ConfirmationDialog
                      title={translate('ra.message.clone_reservation', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenCloneModal}
                      setConfirm={setConfirmClone}
                      open={openCloneModal}
                      loadingModalButton={loadingCloneItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.register_return', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenRegisterReturnModal}
                      setConfirm={setConfirmRegisterReturn}
                      open={openRegisterReturnModal}
                      loadingModalButton={loadingRegisterReturnItem}
                    />
                    <ConfirmationDialog
                      title={translate('ra.message.emit_item_reserva', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenEmitModal}
                      setConfirm={setConfirmEmit}
                      open={openEmitModal}
                    />

                    <ConfirmationDialog
                      title={translate('ra.message.after_sales', { reserva: nameReserve })}
                      buttonConfirmText={translate('ra.message.yes')}
                      buttonCancel={translate('ra.message.no')}
                      setOpen={setOpenAfterSalesModal}
                      setConfirm={setConfirmAfterSales}
                      open={openAfterSalesModal}
                      loadingModalButton={loadingAfterSalesItem}
                    />
                    <ChangeStatusDialog
                      open={changeStatusDialog}
                      setOpen={setChangeStatusDialog}
                      refresh={refresh}
                    />
                    <Dialog open={openMoveModal} onClose={() => setOpenMoveModal(false)}>
                      <DialogTitle>Mover item</DialogTitle>
                      <DialogContent>
                        <Grid container spacing={3}>
                          <EditInputsWrap
                            label={translate('ra.field.reservation_number')}
                            md={12}
                            lg={12}
                            style={{ minHeight: 0 }}
                          >
                            <TextField
                              value={reservationNumberMove}
                              onChange={(e) => setReservationNumberMove(e.target.value)}
                              size='small'
                              fullWidth
                            />
                          </EditInputsWrap>
                        </Grid>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          variant='outlined'
                          onClick={() => {
                            setNameReserve('')
                            setHashItemReserve('')
                            setReservationNumberMove('')
                            setOpenMoveModal(false)
                          }}
                        >
                          Cancelar
                        </Button>
                        <Button variant='contained' onClick={handleMoveItem}>
                          Aceptar
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12} xl={4}>
                    <WrapperCardId>
                      <ContactModal
                        open={openContactModal}
                        loadingButton={loadingContactModal}
                        handleClose={() => setOpenContactModal(false)}
                        onSubmit={(record, cardId) => {
                          handleUpdateContact(
                            record,
                            cardId,
                            setLoadingContactModal,
                            setOpenContactModal,
                            notify,
                            refresh,
                            setCardLoading
                          )
                        }}
                        titleModal={translate('ra.title.update_contact')}
                      />
                      <ShowCard
                        iconHeader={<PhoneIcon />}
                        title={translate('ra.title.contanct')}
                        actionButtonIcon={!editMode && <EditIcon />}
                        variant='text'
                        onClickButton={() => {
                          setOpenContactModal(true)
                        }}
                      >
                        <CompleteSideCard>
                          <ShowElement source='contact.name' label={translate('ra.field.name')} />
                          <ShowElement source='contact.surname' label={translate('ra.field.surname')} />
                          <ShowElement source='contact.email' label={translate('ra.field.email')} />
                          <ShowElement
                            source='contact.phone_number'
                            label={translate('ra.field.phone_number')}
                          />
                        </CompleteSideCard>
                      </ShowCard>
                    </WrapperCardId>

                    <WrapperCardId>
                      <ObservationsCard />
                    </WrapperCardId>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <ShowCard
                      iconHeader={<MedicalServicesIcon />}
                      title={translate('ra.title.assistance_information')}
                    >
                      <CompleteSideCard style={{ display: 'block' }}>
                        <ShowElement
                          source='code'
                          styleValue={{ fontWeight: 600, color: turquoise }}
                          label={translate('ra.field.code')}
                        />
                        <ShowElement
                          source='destination'
                          styleValue={{ fontWeight: 600, color: turquoise }}
                          label={translate('ra.field.destination')}
                          icon={<LocationOnIcon style={{ color: turquoise, paddingTop: '5px' }} />}
                        />
                        {}
                        <VoucherAssistance />
                        <ShowElement source='days_number' label={translate('ra.field.days_number')} />
                        <ShowElement source='name' label={translate('ra.field.coverage')} />
                        <ContextAssistance reservation={reservation} />
                      </CompleteSideCard>
                    </ShowCard>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12} lg={4} xl={4}>
                  <ShowCard iconHeader={<PhoneIcon />} title={translate('ra.title.contact_emergency')}>
                    <CompleteSideCard>
                      <ShowElement
                        source='contact_emergency.contactName'
                        label={translate('ra.field.name')}
                      />
                      <ShowElement
                        source='contact_emergency.contactLastname'
                        label={translate('ra.field.surname')}
                      />
                      <ShowElement
                        source='contact_emergency.contactPhone'
                        label={translate('ra.field.phone')}
                      />
                    </CompleteSideCard>
                  </ShowCard>
                </Grid>
              </WrapperCardId>
              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <NotificationEmails />
                  </Grid>
                </Grid>
              </WrapperCardId>
              <WrapperCardId>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <FilesCard />
                  </Grid>
                </Grid>
              </WrapperCardId>
              <HasPermission permission={PERMISSION_SHOW} resource={'comments'}>
                <WrapperCardId>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <CommentsCardComponent itemId={assistance[0]?.item_id}/>
                    </Grid>
                  </Grid>
              </WrapperCardId>
            </HasPermission>
            </div>
            <div className='responsive-products-pricing'>
              <Box
                style={{
                  position: 'sticky',
                  top: '10px',
                  zIndex: '1000',
                  '&.MuiPaper-root': {
                    overflow: 'visible !important',
                  },
                }}
              >
                <WrapperCardId>
                  {/* <ShowCard
                    iconHeader={<AttachMoneyIcon />}
                    title={translate('ra.title.pricing')}
                    actionButtonIcon={<EditIcon />}
                    optionHeigth={'pricing'}
                    variant='text'
                    onClickButton={() => {
                      setOpenPricingModal(true)
                    }}
                  >
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <Pricing />
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </ShowCard> */}
                </WrapperCardId>
                <WrapperCardId>
                  <PricingModal
                    open={openPricingModal}
                    loadingButton={loadingPricingModal}
                    handleClose={() => setOpenPricingModal(false)}
                    onSubmit={(record, cardId) => {
                      handleUpdatePricing(
                        record,
                        cardId,
                        setLoadingPricingModal,
                        setOpenPricingModal,
                        notify,
                        refresh,
                        setCardLoading,
                        reservation
                      )
                    }}
                    titleModal={translate('ra.title.update_pricing')}
                  />
                  {!editMode && (
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'flex-end'}}>
                      <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                          <HasPermission permission='hasEdit' resource={'pricing'}>
                              <Button
                              onClick={()=>{setHistoryCostsDialog(true)}}
                              sx={{ paddingX: '10px', marginX:'5px' }}
                              size='small'
                              variant='contained'
                              >
                              {translate('ra.title.price_history')}
                              </Button>
                          </HasPermission>
                        </Box>
                      <EditOriginValues setEnableReliquidation={setEnableReliquidation} isBillable={isBillable} setOpenPricingModal={setOpenPricingModal}/>
                      </div>
                  )}

                  {/* <LiquidationModal
                    open={openLiqudiationPricingModal}
                    loadingButton={loadingLiqudiationPricingModal}
                    handleClose={() => {
                      setOpenLiqudiationPricingModal(false)
                      setExchangeMode(false)
                    }}
                    exchange_mode={exchangeMode}
                    onSubmit={(body, cardId) => {
                      handleUpdateLiquidation(
                        individualRecord,
                        body,
                        cardId,
                        setLoadingLiqudiationPricingModal,
                        setOpenLiqudiationPricingModal,
                        notify,
                        refresh,
                        setCardLoading
                      )
                      setExchangeMode(false)
                    }}
                    titleModal={translate('ra.title.update_liquidation')}
                  /> */}
                  <LiquidationCards enableReliquidation={enableReliquidation} work_unit_relation={reservation?.work_unit_relation} />
                </WrapperCardId>
              </Box>
            </div>
          </Box>
        </TabProduct>
      </>
    )
  }
}
